import { connect } from 'react-redux';
import FollowUpSidepanel from '../../components/smart-action-sidepanel/follow-up-sidepanel';
import {
  saveSmartAction,
  createSmartAction,
  fetchSmartAction,
} from './smart-action-sidepanel-actions';

const mapStateToProps = (state) => {
  const {
    ticketForm: { ticket, tags, followUpTypes },
    smartAction: { isSaving, success, error, action, isLoadingAction },
  } = state;

  return {
    ticket,
    action,
    tags,
    isSaving,
    success,
    error,
    isLoadingAction,
    followUpTypes,
  };
};

const mapDispatchToProps = {
  saveSmartAction,
  createSmartAction,
  fetchSmartAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpSidepanel);
